import { React, useState, useEffect, useContext } from 'react';
import Box from '@iso/components/utility/box';
import LayoutWrapper from '@iso/components/utility/layoutWrapper';
import { SelectOption } from '@iso/components/uielements/select';
import { useLocation, useNavigate } from 'react-router-dom';
import ContentHolder from '@iso/components/utility/contentHolder';
import { AppContext } from '../../../context/ContextProvider';
import { AlertContext } from '../../../context/alertContext';
import secretDetectionIcon from '@iso/assets/images/secret-detection-icon.svg';
import CreateTaskHeader from '../../ScrumBoard/Task/TaskCreateOrUpdate/CreateTaskHeader/CreateTaskHeader';
import { StickerWidgetWrapper } from '../../Widgets/SmallCards/SmallCards.styles';
import plusIcon from '@iso/assets/images/plusIcon.svg';


let innerTitleStyle = {
    color: "#1f1f1f",
    fontFamily: "Poppins",
    fontType: "medium",
    fontWeight: "500",
    fontSize: "15px"
};

let innerSubtitleStyle = {
    fontSize: "13px",
    color: "#9B9B9B",
    fontFamily: "Nunito Sans",
    fontWeight: "400",
    fontType: "regular",
}

const widgetStyle = {
    margin: "20px",
    width: "100%",
};

export default ({
    workflowNodeData,
    workflowEdgesData,
    columnId,
}) => {

    const { openRightDrawer, setOpenRightDrawer, workflowData, setWorkflowData } = useContext(AppContext);
    const { alertOptions, set_alertOptions } = useContext(AlertContext);

    const navigate = useNavigate();
    const location = useLocation();

    const handelCancel = () => {
        setOpenRightDrawer({
            drawerType: false,
            drawerProps: {
                data: "",
            },
        });
    }

    function toggleAlert(type, message, description, hide = true, time = 5) {
        set_alertOptions(alertOptions => ({
            status: true,
            type: type,
            message: message,
            description: description,
        }));

        if (hide) {
            // opacity=0 after 10sec
            setTimeout(() => {
                set_alertOptions(alertOptions => ({
                    status: false,
                    type: type,
                    message: message,
                    description: description,
                }));
            }, time * 1000);
        }
    }


    const handleClick = (type) => {
        console.log("clicked handleClick :", type);
        setOpenRightDrawer({
            drawerType: type,
            drawerProps: {
                data: workflowData,
                columnId: columnId,
                type: "build",
                className: "expend",
            },
        });
    }


    return (
        <LayoutWrapper className="clusterInfo" style={{ padding: "0" }}>
            <CreateTaskHeader buttonContent={columnId} onCancel={handelCancel} />

            <div style={{ marginTop: "84px", width: "100%" }} />
            
            <StickerWidgetWrapper className="isoStickerWidget" style={{ ...widgetStyle, marginTop: "20px" }}>
                <Box style={{ borderRadius: "10px", cursor: "pointer", padding: "0" }} onClick={() => handleClick("deployTools", 0)}>
                    <ContentHolder
                        style={{ display: "flex", alignItems: "start", cursor: "pointer", marginTop: "0", position: "relative", padding: "18px", minHeight: "122px" }}
                    >
                        <Box
                            title={
                                <div style={{ display: "flex", justifyContent: "start", alignItems: "center" }}>
                                    <span style={{ display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "100%", width: "36px", height: "36px", background: "white", padding: "3px", boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.25)" }}>
                                        <img src={secretDetectionIcon} />
                                    </span>
                                    <p style={{ color: "#1F1F1F", marginLeft: "5px" }}>Environment</p>
                                </div>
                            }
                            subtitle={<p style={{ lineHeight: "24px", color: "#9B9B9B" }}>Add an environment (Development, Staging, Production) to your workflow. Please note, you will only be able to see ACTIVE environments associated with the service.</p>}
                            style={{ border: "transparent", padding: "0", marginBottom: "0" }}
                            titleStyle={innerTitleStyle}
                            subTitleStyle={innerSubtitleStyle}
                        />
                        <img src={plusIcon} alt="add" style={{ position: "absolute", top: "10px", right: "10px", width: "16px", height: "16px", objectFit: "cover" }} />
                    </ContentHolder>
                </Box>
            </StickerWidgetWrapper>

            {/* <StickerWidgetWrapper className="isoStickerWidget" style={{ ...widgetStyle, marginTop: "20px"}}>
                <Box style={{ borderRadius: "10px", cursor: "pointer", padding: "0" }} onClick={() => handleClick("buildTools", 0)}>
                    <ContentHolder
                        style={{ display: "flex", alignItems: "start", cursor: "pointer", marginTop: "0", position: "relative", padding: "18px", minHeight: "122px" }}
                    >
                        <Box
                            title={
                                <div style={{display:"flex", justifyContent: "start", alignItems: "center"}}>
                                    <span style={{display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "100%", width: "36px", height: "36px", background: "white", padding: "3px", boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.25)"}}>
                                        <img src={sonarcubeIcon} />
                                    </span>
                                    <p style={{ color: "#1F1F1F", marginLeft: "5px" }}>Trivy</p>
                                </div>
                            }
                            subtitle={<p style={{ lineHeight: "24px", color: "#9B9B9B" }}>Trivy is a comprehensive security scanner for vulnerabilities in container images, file systems, and Git repositories. It identifies potential security risks by detecting known vulnerabilities and misconfigurations, ensuring that the deployed application is secure and compliant with industry standards.</p>}
                            style={{ border: "transparent", padding: "0", marginBottom: "0" }}
                            titleStyle={innerTitleStyle}
                            subTitleStyle={innerSubtitleStyle}
                        />
                        <img src={plusIcon} alt="add" style={{ position: "absolute", top: "10px", right: "10px", width: "16px", height: "16px", objectFit: "cover" }} />
                    </ContentHolder>
                </Box>
            </StickerWidgetWrapper> */}

            {/* <StickerWidgetWrapper className="isoStickerWidget" style={{ ...widgetStyle, marginTop: "20px" }}>
                <Box style={{ borderRadius: "10px", cursor: "pointer", padding: "0" }} onClick={() => handleClick("sourceTools")}>
                    <ContentHolder
                        style={{ display: "flex", alignItems: "start", cursor: "pointer", marginTop: "0", position: "relative", padding: "18px", minHeight: "122px" }}
                    >
                        <Box
                            title={
                                <div style={{ display: "flex", justifyContent: "start", alignItems: "center" }}>
                                    <span style={{ display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "100%", width: "36px", height: "36px", background: "white", padding: "3px", boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.25)" }}>
                                        <img src={sonarcubeIcon} />
                                    </span>
                                    <p style={{ color: "#1F1F1F", marginLeft: "5px" }}>Trivy</p>
                                </div>
                            }
                            subtitle={<p style={{ lineHeight: "24px", color: "#9B9B9B" }}>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the</p>}
                            style={{ border: "transparent", padding: "0", marginBottom: "0" }}
                            titleStyle={innerTitleStyle}
                            subTitleStyle={innerSubtitleStyle}
                        />
                        <img src={plusIcon} alt="add" style={{ position: "absolute", top: "10px", right: "10px", width: "16px", height: "16px", objectFit: "cover" }} />
                    </ContentHolder>
                </Box>
            </StickerWidgetWrapper>

            <StickerWidgetWrapper className="isoStickerWidget" style={{ ...widgetStyle, marginTop: "20px" }}>
                <Box style={{ borderRadius: "10px", cursor: "pointer", padding: "0" }} onClick={() => handleClick("sourceTools")}>
                    <ContentHolder
                        style={{ display: "flex", alignItems: "start", cursor: "pointer", marginTop: "0", position: "relative", padding: "18px", minHeight: "122px" }}
                    >
                        <Box
                            title={
                                <div style={{ display: "flex", justifyContent: "start", alignItems: "center" }}>
                                    <span style={{ display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "100%", width: "36px", height: "36px", background: "white", padding: "3px", boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.25)" }}>
                                        <img src={sonarcubeIcon} />
                                    </span>
                                    <p style={{ color: "#1F1F1F", marginLeft: "5px" }}>Tool 3</p>
                                </div>
                            }
                            subtitle={<p style={{ lineHeight: "24px", color: "#9B9B9B" }}>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the</p>}
                            style={{ border: "transparent", padding: "0", marginBottom: "0" }}
                            titleStyle={innerTitleStyle}
                            subTitleStyle={innerSubtitleStyle}
                        />
                        <img src={plusIcon} alt="add" style={{ position: "absolute", top: "10px", right: "10px", width: "16px", height: "16px", objectFit: "cover" }} />
                    </ContentHolder>
                </Box>
            </StickerWidgetWrapper> */}
        </LayoutWrapper>
    );
};